
import { useState } from "react"
import { supabase } from "@/integrations/supabase/client"
import { useToast } from "@/hooks/use-toast"

export const useAssessmentDeletion = (onSuccess?: () => void) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const { toast } = useToast()

  const deleteAssessment = async (assessmentId: string) => {
    if (!assessmentId) return

    try {
      setIsDeleting(true)
      console.log("Attempting to delete assessment:", assessmentId)

      const { error } = await supabase
        .from("assessments")
        .delete()
        .eq("id", assessmentId)
        .eq("status", "draft") // Safety check: only delete drafts

      if (error) {
        console.error("Error deleting assessment:", error)
        toast({
          title: "Error",
          description: "Failed to delete assessment. Please try again.",
          variant: "destructive",
        })
        throw error
      }

      console.log("Assessment deleted successfully:", assessmentId)
      toast({
        title: "Success",
        description: "Assessment has been deleted successfully.",
      })

      if (onSuccess) {
        onSuccess()
      }
    } catch (error) {
      console.error("Unexpected error deleting assessment:", error)
    } finally {
      setIsDeleting(false)
    }
  }

  return {
    deleteAssessment,
    isDeleting
  }
}
